const s=(s,t)=>s[t]?Object.assign(Object.assign({},s),s[t]):Object.assign({},s);export{s as getOptions};
